<script lang="ts">
    import { formatUsage, usagePercent } from './UsageStatsApp';

    export let value: number;
    export let limit: number | null;

    /** `null` = konto bez limitu: zostaje sam tekst 'uzycie / ∞', bo procent nie ma mianownika. */
    $: percent = usagePercent(value, limit);
    /** Wypelnienie ucinamy do 100% - przekroczenie sygnalizuje kolor procentu, nie dlugosc paska. */
    $: fillWidth = percent === null ? 0 : Math.min(Math.max(percent, 0), 100);
</script>

<div class="usage-limit-bar">
    {#if percent === null}
        <span class="usage-text">{formatUsage(value, limit)}</span>
    {:else}
        <div class="usage-header">
            <span class="usage-text">{formatUsage(value, limit)}</span>
            <span class="usage-percent" class:over-limit={percent > 100} class:near-limit={percent >= 80 && percent <= 100}>
                {Math.round(percent)}%
            </span>
        </div>
        <div class="usage-bar" role="progressbar" aria-valuenow={Math.round(percent)} aria-valuemin="0" aria-valuemax="100">
            <div class="usage-bar-fill" style="width: {fillWidth}%"></div>
        </div>
    {/if}
</div>

<style>
    .usage-limit-bar {
        min-width: 120px;
        text-align: right;
    }
    .usage-header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        column-gap: 12px;
        white-space: nowrap;
    }
    .usage-bar {
        margin-top: 3px;
        height: 8px;
        border-radius: 4px;
        background-color: var(--automapa-grey-light);
        overflow: hidden;
    }
    .usage-bar-fill {
        height: 100%;
        border-radius: 4px;
        background-color: var(--automapa-blue);
    }
    /* limit przekroczony - jedyny nosnik alarmu, komorka nie zmienia juz koloru */
    .usage-percent.over-limit {
        color: var(--automapa-red);
        font-weight: bold;
    }
    /* ostatnie 20% zapasu - ostrzezenie, zanim limit zacznie blokowac routing i import */
    .usage-percent.near-limit {
        color: var(--automapa-orange);
        font-weight: bold;
    }
</style>
